import React, { useState } from "react";
import PropTypes from "prop-types";

import { Row, Col } from "reactstrap";

import ListingCard from "../Listing/ListingCard";
import { CollectionView } from "../../api/firebase";

const ListingSection = props => {
  const [docs, setDocs] = useState([]);

  if (props.listingsView === null) return <div></div>;

  if (!props.listingsView.started) {
    props.listingsView.start(["status.offer_id", "==", null]).then(setDocs);
  }

  return (
    <Row
      style={{
        paddingTop: "1em",
        overflowY: "auto",
        scrollbarWidth: "none"
      }}
    >
      {docs.map(doc => (
        <Col key={doc.id} xs={12} md={5} xl={4}>
          <ListingCard
            noImage={props.noImage}
            doc={doc.ref}
            data={doc.data()}
          />
        </Col>
      ))}
    </Row>
  );
};

ListingSection.propTypes = {
  listingsView: PropTypes.instanceOf(CollectionView)
};

export default ListingSection;
